<po-page-list p-title="Netrin - Atualizar Cadastro (Cliente e Fornecedor)" [p-breadcrumb]="poPageBreadcrumb" [p-actions]="poPageActions" [p-filter]="poPoPageFilter">
  <po-table
    #tabelaPrincipal
    class="po-md-12"
    [p-container]="true"
    [p-height]="500"
    [p-actions]="tabelaPrincipalActions"
    [p-items]="tabelaPrincipalDados"
    [p-columns]="tabelaPrincipalColumns"
    [p-hide-table-search]="false"
    [p-text-wrap]="true"
    [p-selectable]="true"
    [p-sort]="true"
    [p-selectable-entire-line]="true"
    [p-hide-select-all]="false"
    p-spacing="small"
    (p-change-visible-columns)="salvarColunas()"
  ></po-table>
</po-page-list>

<po-modal #modalVerProcesso class="modal-ver-processo" p-title="Processo de Atualização de Cadastro (Selecione os registro que deseja alterar)">
  <po-tabs class="po-md-12">
    <po-tab p-label="Atualizar Cadastro" [p-active]="true" class="po-md-12">
      <po-widget>
        <po-widget class="po-md-12">
          <po-tag
            class="po-md-12 po-xl-6"
            p-color="color-10" p-label="Código"
            [p-value]="dadosEmAtualizacao.CCODIGO"
          ></po-tag>
          <po-tag
            class="po-md-12 po-xl-2"
            p-label="Tipo"
            [p-value]="dadosEmAtualizacao.CTIPO === 'C' ? 'Cliente' : 'Fornecedor'"
            p-color="color-10"
          ></po-tag>
          <po-tag
            class="po-md-12 po-xl-2"
            p-label="Cadastro Ativo?"
            [p-value]="['ATIVA','ATIVO','2'].includes(dadosEmAtualizacao.CATIVO) ? 'Sim' : 'Não' "
            [p-color]="['ATIVA','ATIVO','2'].includes(dadosEmAtualizacao.CATIVO) ? 'color-10' : 'color-03'"
          ></po-tag>
          <po-tag
            class="po-md-12 po-xl-2"
            p-label="Optante pelo Simples Nacional?"
            [p-value]="dadosEmAtualizacao.CSIMPNAC === '1' ? 'Sim'      : dadosEmAtualizacao.CSIMPNAC === '2'  ?'Não'      : 'Não Informado'"
            [p-color]="dadosEmAtualizacao.CSIMPNAC === '1' ? 'color-10' : dadosEmAtualizacao.CSIMPNAC === '2'  ?'color-03' : 'color-04'"
          ></po-tag>
        </po-widget>
        <po-widget class="po-md-12">
          <div class="po-row po-md-12">
            <div class="po-md-12 po-xl-2"></div>
            <po-tag p-color="color-03" p-value="Antigo" class="po-md-12 po-xl-4"></po-tag>
            <po-tag p-color="color-10" p-value="Novo" class="po-md-12 po-xl-6"></po-tag>
          </div>

          <po-divider class="po-md-12"></po-divider>

          <div class="po-row po-md-12">
            <po-tag p-value="Nome" class="po-md-12 po-xl-1 po-mt-1" p-color="color-01"></po-tag>
            <po-checkbox
              class="po-md-12 po-xl-1 po-mt-1"
              name="LNOME"
              [(ngModel)]="dadosEmAtualizacao.LNOME"
            ></po-checkbox>
            <po-info
              class="po-md-12 po-xl-4"
              [p-value]="dadosCliente.CA1NOME || dadosFornecedor.CA2NOME"
            ></po-info>
            <po-input
              class="po-md-12 po-xl-6"
              name="CNOME"
              [(ngModel)]="dadosEmAtualizacao.CNOME"
              [p-readonly]="!dadosEmAtualizacao.LNOME"
              [p-maxlength]="60"
            ></po-input>
          </div>

          <po-divider class="po-md-12"></po-divider>

          <div class="po-row po-md-12">
            <po-tag p-value="Nome Fantasia" class="po-md-12 po-xl-1 po-mt-1" p-color="color-01"></po-tag>
            <po-checkbox
              class="po-md-12 po-xl-1 po-mt-1"
              name="LNOMEFANTASIA"
              [(ngModel)]="dadosEmAtualizacao.LNOMEFANTASIA"
            ></po-checkbox>
            <po-info
              class="po-md-12 po-xl-4"
              [p-value]="dadosCliente.CA1NREDUZ || dadosFornecedor.CA2NREDUZ"
            ></po-info>
            <po-input
              class="po-md-12 po-xl-6"
              name="CNOMEFANTASIA"
              [(ngModel)]="dadosEmAtualizacao.CNOMEFANTASIA"
              [p-readonly]="!dadosEmAtualizacao.LNOMEFANTASIA"
              [p-maxlength]="20"
            ></po-input>
          </div>

          <po-divider class="po-md-12"></po-divider>

          <div class="po-row po-md-12">
            <po-tag p-value="Endereço" class="po-md-12 po-xl-1 po-mt-1" p-color="color-01"></po-tag>
            <po-checkbox
              class="po-md-12 po-xl-1 po-mt-1"
              name="LEND"
              [(ngModel)]="dadosEmAtualizacao.LEND"
            ></po-checkbox>
            <po-info
              class="po-md-12 po-xl-4"
              [p-value]="dadosCliente.CA1END || dadosFornecedor.CA2END"
            ></po-info>
            <po-input
              class="po-md-12 po-xl-6"
              name="CEND"
              [(ngModel)]="dadosEmAtualizacao.CEND"
              [p-readonly]="!dadosEmAtualizacao.LEND"
              [p-maxlength]="60"
            ></po-input>
          </div>

          <po-divider class="po-md-12"></po-divider>

          <div class="po-row po-md-12">
            <po-tag p-value="Complemento" class="po-md-12 po-xl-1 po-mt-1" p-color="color-01"></po-tag>
            <po-checkbox
              class="po-md-12 po-xl-1 po-mt-1"
              name="LCOMPLEM"
              [(ngModel)]="dadosEmAtualizacao.LCOMPLEM"
            ></po-checkbox>
            <po-info
              class="po-md-12 po-xl-4"
              [p-value]="dadosCliente.CA1COMPLEM|| dadosFornecedor.CA2COMPLEM"
            ></po-info>
            <po-input
              class="po-md-12 po-xl-6"
              name="CCOMPLEM"
              [(ngModel)]="dadosEmAtualizacao.CCOMPLEM"
              [p-readonly]="!dadosEmAtualizacao.LCOMPLEM"
              [p-maxlength]="50"
            ></po-input>
          </div>

          <po-divider class="po-md-12"></po-divider>

          <div class="po-row po-md-12">
            <po-tag p-value="CEP" class="po-md-12 po-xl-1 po-mt-1" p-color="color-01"></po-tag>
            <po-checkbox
              class="po-md-12 po-xl-1 po-mt-1"
              name="LCEP"
              [(ngModel)]="dadosEmAtualizacao.LCEP"
            ></po-checkbox>
            <po-info
              class="po-md-12 po-xl-4"
              [p-value]="dadosCliente.CA1CEP|| dadosFornecedor.CA2CEP"
            ></po-info>
            <po-input
              class="po-md-12 po-xl-6"
              name="CINSCR"
              [(ngModel)]="dadosEmAtualizacao.CCEP"
              [p-readonly]="!dadosEmAtualizacao.LCEP"
              [p-maxlength]="8"
            ></po-input>
          </div>

          <po-divider class="po-md-12"></po-divider>

          <div class="po-row po-md-12">
            <po-tag p-value="Município " class="po-md-12 po-xl-1 po-mt-1" p-color="color-01"></po-tag>
            <po-checkbox
              class="po-md-12 po-xl-1 po-mt-1"
              name="LMUN"
              [(ngModel)]="dadosEmAtualizacao.LMUN"
            ></po-checkbox>
            <po-info
              class="po-md-12 po-xl-4"
              [p-value]="dadosCliente.CA1MUN|| dadosFornecedor.CA2MUN"
            ></po-info>
            <po-input
              class="po-md-12 po-xl-6"
              name="CMUN"
              [(ngModel)]="dadosEmAtualizacao.CMUN"
              [p-readonly]="!dadosEmAtualizacao.LMUN"
              [p-maxlength]="60"
            ></po-input>
          </div>

          <po-divider class="po-md-12"></po-divider>

          <div class="po-row po-md-12">
            <po-tag p-value="Inscrição Estadual" class="po-md-12 po-xl-1 po-mt-1" p-color="color-01"></po-tag>
            <po-checkbox
              class="po-md-12 po-xl-1 po-mt-1"
              name="LINSCR"
              [(ngModel)]="dadosEmAtualizacao.LINSCR"
            ></po-checkbox>
            <po-info
              class="po-md-12 po-xl-4"
              [p-value]="dadosCliente.CA1INSCR|| dadosFornecedor.CA2INSCR"
            ></po-info>
            <po-input
              class="po-md-12 po-xl-6"
              name="CINSCR"
              [(ngModel)]="dadosEmAtualizacao.CINSCR"
              [p-readonly]="!dadosEmAtualizacao.LINSCR"
              [p-maxlength]="18"
            ></po-input>
          </div>
        </po-widget>

      </po-widget>
    </po-tab>
    <po-tab p-label="Dados">
      <po-widget >
        <json-editor
          class="po-md-12"
          [data]="dadosEmAtualizacao.OJSONDADOS"
          [options]="jsonEditorOptions"
        ></json-editor>
      </po-widget>
    </po-tab>
  </po-tabs>
  <po-modal-footer>
    <po-button
      class="po-md-12"
      p-label="Salvar"
      p-kind="primary"
      (p-click)="salvaItemAnalisado()"
    ></po-button>
  </po-modal-footer>
</po-modal>

<po-modal #modalDadosErro p-title="Dados do Erro" p-size="xl">
  <po-widget>
    <po-info class="po-md-12" p-label="Mensagem de Erro" [p-value]="dadosEmAtualizacao.CMENSAGEMERRO"></po-info>
    <json-editor
      class="po-md-12"
      [data]="dadosEmAtualizacao.OJSONERRO"
      [options]="jsonEditorOptions"
    ></json-editor>
  </po-widget>
</po-modal>

<po-modal #modalFiltroAvancadoTabelaPrincipal p-title="Filtro" [p-primary-action]="modalFiltroAvancadoTabelaPrincipalActions">
  <po-datepicker
    class="po-md-12 po-xl-12"
    p-label="Data da Última Consulta:"
    p-placeholder="Selecione uma data"
    name="DATU"
    [(ngModel)]="tabelaPrimariaFiltro.dados.DATU"
    [p-required]="false"
    [p-format]="{ day: '2-digit', month: '2-digit', year: 'numeric' }"
    [p-clean]="true"
  ></po-datepicker>
  <po-combo
    class="po-md-12 po-xl-6"
    p-label="Tipo"
    p-placeholder="Selecione um tipo"
    name="CTIPO"
    [(ngModel)]="tabelaPrimariaFiltro.dados.CTIPO"
    [p-options]="tabelaPrimariaFiltro.tipoOrigemPoComboOptions"
    [p-required]="false"
    [p-clean]="true"
  ></po-combo>
  <po-combo
    class="po-md-12 po-xl-6"
    p-label="Status"
    p-placeholder="Selecione um tipo"
    name="CSTATUS"
    [(ngModel)]="tabelaPrimariaFiltro.dados.CSTATUS"
    [p-options]="tabelaPrimariaFiltro.statusProcessoPoComboOptions"
    [p-required]="false"
    [p-clean]="true"
  ></po-combo>
  <po-lookup class="po-md-12 po-xl-6"
    p-label="Fornecedor"
    p-placeholder="Pesquisar"
    name="CFORNECEDORLOJA"
    [(ngModel)]="tabelaPrimariaFiltro.dados.CFORNECEDORLOJA"
    p-field-label="CA2NREDUZ"
    p-field-value="CA2CODLOJA"
    [p-columns]="fornecedorColumnsFilters"
    [p-field-format]="fornecedorLookupService.getFieldFormater"
    [p-filter-service]="fornecedorLookupService"
    [p-advanced-filters]="fornecedorLookupService.getAdvancedFilter()"
    [p-literals]="{ modalTitle: 'Fornecedor' }"
    [p-clean]="true"
  ></po-lookup>
  <po-lookup
    class="po-md-12 po-xl-6"
    p-placeholder="Pesquisar"
    name="CCLIENTELOJA"
    [(ngModel)]="tabelaPrimariaFiltro.dados.CCLIENTELOJA"
    p-field-label="CA1NREDUZ"
    p-field-value="CA1CODLOJA"
    p-label="Cliente"
    [p-columns]="clienteLookupService"
    [p-field-format]="clienteLookupService.getFieldFormater"
    [p-filter-service]="clienteLookupService"
    [p-advanced-filters]="clienteLookupService.getAdvancedFilter()"
    [p-literals]="{ modalTitle: 'Cliente' }"
    [p-clean]="true"
  ></po-lookup>
</po-modal>
